import { ApplicationCategoryEnum } from '@electricjs/core_entity-client';

/**
 * Display order + i18n key (under the `applications:category` namespace) for
 * each real `ApplicationCategoryEnum` value. Mirrors the options built inline
 * in InternalApplicationForm.tsx, kept here so the Add Applications category
 * filter can reuse the same mapping.
 */
export const APPLICATION_CATEGORY_OPTIONS: {
  value: ApplicationCategoryEnum;
  i18nKey: string;
}[] = [
  {
    value: ApplicationCategoryEnum.ProductivityCollaboration,
    i18nKey: 'category.productivityCollaboration',
  },
  {
    value: ApplicationCategoryEnum.HrPeopleOps,
    i18nKey: 'category.hrPeopleOps',
  },
  { value: ApplicationCategoryEnum.ItSecurity, i18nKey: 'category.itSecurity' },
  {
    value: ApplicationCategoryEnum.EngineeringDevelopment,
    i18nKey: 'category.engineeringDevelopment',
  },
  {
    value: ApplicationCategoryEnum.SalesMarketing,
    i18nKey: 'category.salesMarketing',
  },
  {
    value: ApplicationCategoryEnum.FinanceAccounting,
    i18nKey: 'category.financeAccounting',
  },
  {
    value: ApplicationCategoryEnum.DesignCreative,
    i18nKey: 'category.designCreative',
  },
  {
    value: ApplicationCategoryEnum.DataAnalytics,
    i18nKey: 'category.dataAnalytics',
  },
  {
    value: ApplicationCategoryEnum.CustomerSupport,
    i18nKey: 'category.customerSupport',
  },
  { value: ApplicationCategoryEnum.Other, i18nKey: 'category.other' },
];

export const APPLICATION_CATEGORY_I18N_KEY_BY_VALUE: Record<string, string> =
  Object.fromEntries(
    APPLICATION_CATEGORY_OPTIONS.map(({ value, i18nKey }) => [value, i18nKey])
  );

/**
 * Canonical slugs for applications that we special-case in the UI.
 *
 * Using `as const` objects (rather than `enum`) keeps the values structurally
 * typed so they can be compared against any string without runtime surprises.
 */
export const ApplicationSlug = {
  GoogleWorkspace: 'google-workspace',
  Microsoft365: 'microsoft-365',
  MicrosoftEntraId: 'microsoft-entra-id',
  MicrosoftIntune: 'microsoft-intune',
  MicrosoftActiveDirectory: 'microsoft-on-prem-active-directory',
  GitHub: 'github',
} as const;

export type ApplicationSlug =
  (typeof ApplicationSlug)[keyof typeof ApplicationSlug];

/**
 * Setting names that drive the Google Workspace license assignment UI.
 * These match the backend `RequestTypeSetting.name` values so both the
 * checkbox and the dropdown survive a normal settings save roundtrip.
 */
export const GoogleWorkspaceLicenseSettingNames = {
  ManuallySelectLicenses: 'manually_select_licenses',
  LicenseSkuIds: 'license_sku_ids',
} as const;
